import { useState } from "react";
import { Collapse, Flex, Text, Box } from "@chakra-ui/react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import CardDefault from "components/Cards/CardDefault";
import OutlineButton from "ui/components/Button/OutlineButton";
import colors from "core/resources/theme/colors";

interface CollapsibleCardProps {
  titleCard: string;
  subtitleCard: string;
  children: any;
  onSave?: () => any;
}

export default function CollapsibleCard({
  titleCard,
  subtitleCard,
  children,
  onSave,
}: CollapsibleCardProps) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <CardDefault pb={4} overflow="visible">
      <Flex
        justifyContent="flex-start"
        mb={2}
        px={0.5}
        cursor="pointer"
        onClick={() => setCollapsed((state) => !state)}
      >
        <Flex flexDir="column" w={!collapsed && onSave ? "80%" : undefined}>
          <Text fontWeight="bold" fontSize="16px" color={colors.black}>
            {titleCard}
          </Text>
          <Text color={colors.black600}>{subtitleCard}</Text>
        </Flex>

        {!collapsed && onSave ? (
          <OutlineButton
            ml="auto"
            py={2}
            h={30}
            w="80px"
            mt={-1}
            onClick={(ev) => {
              ev.stopPropagation();
              onSave();
            }}
          >
            Salvar
          </OutlineButton>
        ) : null}

        <Box ml={!collapsed && onSave ? "16px" : "auto"}>
          {collapsed ? (
            <BsChevronDown fontSize={20} />
          ) : (
            <BsChevronUp fontSize={20} />
          )}
        </Box>
      </Flex>
      <Collapse in={!collapsed}>
        <Box overflow="visible" pt={4} px={0.5}>
          {children}
        </Box>
      </Collapse>
    </CardDefault>
  );
}
